export default __webpack_public_path__ + "static/media/circle_empty.d4583e82.svg";